import { Link } from "react-router";

import { ImageWithFallback } from "simplydo/react/components/ImageWithFallback";
import { styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";
import { Popup } from "simplydo/react/ui/popup";
import type { UiColor } from "simplydo/react/ui/utils/colors";

import util from "utils/utils";

import { getRoleIcon } from "components/lib/Roles/roleIcons";

import { StyledSearchItem } from "./SearchItem";
import type { OmniSearchUser } from "./types";

const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    line-height: 1rem;
  }
`;

type UserSearchItemProps = {
  user: OmniSearchUser;
  active?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const UserSearchItem = ({
  user,
  active,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: UserSearchItemProps) => {
  const { profile } = user;
  const fullName = profile?.fullName ?? "";
  const jobTitle = profile?.jobTitle ?? "";
  const department = profile?.department ?? "";
  return (
    <StyledSearchItem
      onClick={onClick}
      $active={active}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      asChild
    >
      <Link to={`/users/${user._id}`}>
        <ImageWithFallback
          avatar
          src={util.avatarUrl(user)}
          fallbackSrc={util.avatarUrl()}
          style={{ height: "1rem", width: "1rem" }}
        />
        <StyledInfoContainer>
          <p style={{ marginBottom: 0 }}>
            {fullName}
            {user.iconRoles?.[0] ? (
              <Popup
                trigger={
                  <Icon
                    icon={getRoleIcon(user.iconRoles[0]?.icon?.name)}
                    color={user.iconRoles[0]?.icon?.colour as UiColor}
                    style={{ marginLeft: 5 }}
                  />
                }
              >{`This user has the following role: ${user.iconRoles[0]?.name}`}</Popup>
            ) : null}
          </p>
          {(jobTitle || department) && (
            <p style={{ marginBottom: 0, color: "#4e585c", fontSize: 12 }}>
              {jobTitle}
              {jobTitle && department && " - "}
              {department}
            </p>
          )}
        </StyledInfoContainer>
      </Link>
    </StyledSearchItem>
  );
};

export default UserSearchItem;
